import script from "./CoreVisitHistoryReportManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreVisitHistoryReportManager.vue?vue&type=script&setup=true&lang=js"

import "./CoreVisitHistoryReportManager.vue?vue&type=style&index=0&id=e54e4dde&scoped=true&lang=css"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e54e4dde"]])

export default __exports__